import React from 'react'
import * as Styled from './Label.styles'

const Label = ({
  height = 0,
  labelType = null,
  labelRef = null,
  text = null,
}) => {
  if (!text) return null
  return (
    <Styled.Label
      className="package-label"
      ref={labelRef}
      height={height}
      labelType={labelType}
      dangerouslySetInnerHTML={{ __html: `${text}`.trim() }}
    />
  )
}

/* eslint-enable react/no-danger */
export default Label
